import React from 'react';

let Home = () => (
  <div>
    <h1>Mr.Green Studio</h1>
    <p>Indie game studio from Tamil Nadu.</p>
    <p>
    </p>
  </div>
);

export default Home;
